const priorityOptions = [
  { label: "EP4", value: "EP4" },
  { label: "EP3", value: "EP3" },
  { label: "EP2", value: "EP2" },
  { label: "EP1", value: "EP1" },
];

const affectedUserOptions = [
  { label: "Internal", value: "Internal" },
  { label: "External", value: "External" },
  { label: "Both", value: "Both" },
];

const statusOptions = [
  { label: "Log / Classify", value: "Log / Classify" },
  { label: "Diagnose", value: "Diagnose" },
  { label: "Resolve", value: "Resolve" },
];
export {
  priorityOptions,
  affectedUserOptions,
  statusOptions,
};
